export const FOLLOW_POST_LIST_REQUEST = "FOLLOW_POST_LIST_REQUEST";
export const FOLLOW_POST_LIST_SUCCESS = "FOLLOW_POST_LIST_SUCCESS";
export const FOLLOW_POST_LIST_FAIL = "FOLLOW_POST_LIST_FAIL";

export const FOLLOWER_LIST_REQUEST = "FOLLOWER_LIST_REQUEST";
export const FOLLOWER_LIST_SUCCESS = "FOLLOWER_LIST_SUCCESS";
export const FOLLOWER_LIST_FAIL = "FOLLOWER_LIST_FAIL";

export const FOLLOWING_LIST_REQUEST = "FOLLOWING_LIST_REQUEST";
export const FOLLOWING_LIST_SUCCESS = "FOLLOWING_LIST_SUCCESS";
export const FOLLOWING_LIST_FAIL = "FOLLOWING_LIST_FAIL";

export const FOLLOW_USER_REQUEST = "FOLLOW_USER_REQUEST";
export const FOLLOW_USER_SUCCESS = "FOLLOW_USER_SUCCESS";
export const FOLLOW_USER_FAIL = "FOLLOW_USER_FAIL";

export const UNFOLLOW_USER_REQUEST = "UNFOLLOW_USER_REQUEST";
export const UNFOLLOW_USER_SUCCESS = "UNFOLLOW_USER_SUCCESS";
export const UNFOLLOW_USER_FAIL = "UNFOLLOW_USER_FAIL";
